import { commitinfo } from './00_commitinfo_data.js';
import * as serviceworker from '@losslessone_private/lele-serviceworker';

import * as domtools from '@design.estate/dees-domtools';

import '@losslessone_private/lele-catalog';
import '@consent.software_private/catalog';
import '@social.io_private/catalog';
import '@workspace.global_private/catalog';

import { html, render } from '@design.estate/dees-element';
import { LosslessSectionProjects } from './elements/section.projects.js';

const slogan = 'Corporate Data Vault';
const subSlogan = 'Smart, Searchable, Compliant, Secure, and Scalable';

const run = async () => {
  const domtoolsInstance = await domtools.DomTools.setupDomTools();
  domtools.elementBasic.setup();
  domtoolsInstance.setWebsiteInfo({
    metaObject: {
      title: `lossless.com - ${slogan}`,
      description:
        `backup your Open Source stack's data.`,
      canonicalDomain: 'https://lossless.com',
      ldCompany: {
        name: 'Task Venture Capital GmbH',
        status: 'active',
        contact: {
          address: {
            name: 'Task Venture Capital GmbH',
            city: 'Bremen',
            country: 'Germany',
            houseNumber: '5',
            postalCode: '28359',
            streetName: 'Karl-Ferdinand-Braun Str. 5',
          },
          description: 'work',
          name: 'Task Venture Capital GmbH',
          type: 'company',
          facebookUrl: 'https://www.facebook.com/losslesscom',
          twitterUrl: 'https://twitter.com/losslesscom',
          website: 'https://lossless.com',
          phone: '+49 421 989 707 60',
        },
        closedDate: null,
        foundedDate: {
          day: 1,
          month: 1,
          year: 2014,
        },
      },
    },
  });

  const serviceWorker = serviceworker.getServiceWorker();

  const mainTemplate = html`
    <style>
      /* website specific global styles go here */
    </style>
    <lele-theme>
      <lele-statusbar
        siteText=${slogan}
        .commitinfo=${commitinfo}
        .commitinfos=${[
          (await import('@losslessone_private/lele-catalog')).commitinfo,
        ]}
      ></lele-statusbar>
      <lele-header
        .slogan=${slogan}
        .subSlogan=${subSlogan}
        .menuItems="${[
          {
            name: 'Strategies',
            action: async() => {
              console.log('clicked Company');
              const domtoolsInstance: domtools.DomTools = domtools.DomTools.getGlobalDomToolsSync();
              domtoolsInstance.scroller.toElement(
                document
                  .querySelector('lossless-section-projects')
                  .shadowRoot.querySelectorAll('h1')
                  .item(0),
                {
                  offset: -80,
                  easing: 'easeInOutExpo',
                }
              );
            },
          },
          {
            name: 'Pricing',
            action: async () => {
              const domtoolsInstance: domtools.DomTools = domtools.DomTools.getGlobalDomToolsSync();
              domtoolsInstance.scroller.toElement(
                document
                  .querySelector('lossless-section-projects')
                  .shadowRoot.querySelectorAll('h1')
                  .item(2),
                {
                  offset: -80,
                  easing: 'easeInOutExpo',
                }
              );
            },
          },
        ]}"
      ></lele-header>
      <lossless-section-projects></lossless-section-projects>
      <!--<wg-calltoaction .lineOne=${'lossless.com integrates with'}></wg-calltoaction>-->
      <lele-footer .commitinfo=${commitinfo}></lele-footer>
      <consentsoftware-cookieconsent></consentsoftware-cookieconsent>
      <sio-fab style="position: fixed;"></sio-fab>
    </lele-theme>
  `;

  render(mainTemplate, document.body);
};

run();
